import { MapTo } from '@adobe/cq-react-editable-components';
import DOMPurify from 'dompurify';
import React, { Component } from 'react';
import extractModelId from '../../utils/extract-model-id';

const TextEditConfig = {
  emptyLabel: 'Text',

  isEmpty: function(props: any): boolean {
    return !props || !props.text || props.text.trim().length < 1;
  },
};

class Text extends Component {
  props: any;

  get richTextContent(): JSX.Element {
    return (
      <div
        id={extractModelId(this.props.cqPath)}
        data-rte-editelement
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(this.props.text),
        }}
      />
    );
  }

  get textContent(): JSX.Element {
    return <div>{this.props.text}</div>;
  }

  render(): JSX.Element {
    return this.props.richText ? this.richTextContent : this.textContent;
  }
}

export default MapTo('workplace-spa/components/text')(Text, TextEditConfig);
